import Crud from './crud'
import { request_list, post_data } from '@/commons/hpod';
import { refreshResource } from '@/commons/utils';
var crud = new Crud('carts', 'giỏ hàng');

const state = {
    ...crud.state,
    selected: {
        id: 0
    },
    top10: {},
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getTop10({ commit }, param = {pagination: {page: 1, itemsPerPage: 5, sortDesc: [1], sortBy: ["id"]}, filter: [], quickFilter: []}) {
        request_list('carts', data => {
            commit('setTop10', data);
        }, param, this.state.authentication.token);
    },
    removeBath({ commit }, param) {
        post_data('carts', data => {
            refreshResource();
            refreshCart();
        }, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setTop10(state, data) {
        state.top10 = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};